/*       */

import { help } from 'app/utils/designer/form/settings/common/commonHelpers';
import { name, label } from 'app/utils/designer/form/settings/common/commonBase';
import { onLoad, onChange, isVisible, isDisabled } from 'app/utils/designer/form/settings/common/commonEvents';
import { flexGrow } from 'app/utils/designer/form/settings/common/commonStyles';
import { readOnly, staticAttribute, classRequired } from 'app/utils/designer/form/settings/common/commonValidation';
const panels = settingsValues => [
    {
        header: 'Base',
        children: [
            name,
            label,
            {
                type: 'typeahead',
                properties: {
                    label: 'Link target',
                    name: 'properties.target',
                    valueField: 'value',
                    clearable: false,
                    options: [
                        { value: '_self', label: 'Same Tab' },
                        { value: '_blank', label: 'New Tab' },
                        { value: 'dialog', label: 'Dialog' },
                        { value: 'newWindow', label: 'New Window' },
                    ],
                    onChange: String(function(event) {
                        const { value, name } = event.target;
                        const resetWindowSize = [
                            {name : 'properties.windowHeight', value: null},
                            {name : 'properties.windowWidth', value: null},
                        ];
                        const resetDialogSize = [
                            {name : 'properties.dialogHeight', value: null},
                            {name : 'properties.dialogWidth', value: null},
                        ];
                        if (value === '_self' || value === '_blank') {
                            return [
                                ...resetWindowSize,
                                ...resetDialogSize,
                                { name, value },
                            ];
                        }
                        if (value === 'dialog') {
                            return [
                                ...resetWindowSize,
                                { name, value },
                            ];
                        }
                        if (value === 'newWindow') {
                            return [
                                ...resetDialogSize,
                                { name, value },
                            ];
                        }
                        return [
                            ...resetWindowSize,
                            ...resetDialogSize,
                            { name, value },
                        ];
                    }),
                },
            },
            {
                type: 'number',
                properties: {
                    isVisible: ({ properties }) => properties.target === 'newWindow',
                    label: 'Window width',
                    name: 'properties.windowWidth',
                },
                constraints: { 
                    custom: data => {
                        if(data?.properties?.windowWidth < 320){
                            return { 
                                format: { 
                                    pattern: /somefaketest/, 
                                    message: `Min window width 320px.` } };
                        }
                        return {};
                    }
                },
            },
            {
                type: 'number',
                properties: {
                    isVisible: ({ properties }) => properties.target === 'newWindow',
                    label: 'Window height',
                    name: 'properties.windowHeight',
                },
                constraints: { 
                    custom: data => {
                        if(data?.properties?.windowHeight < 480){
                            return { 
                                format: { 
                                    pattern: /somefaketest/, 
                                    message: `Min window height 480px.` } };
                        }
                        return {};
                    }
                },
            },
            {
                type: 'number',
                properties: {
                    isVisible: ({ properties }) => properties.target === 'dialog',
                    label: 'Dialog width',
                    name: 'properties.dialogWidth',
                },
                constraints: { 
                    custom: data => {
                        if(data?.properties?.dialogWidth < 320){
                            return { 
                                format: { 
                                    pattern: /somefaketest/, 
                                    message: `Min dialog width 320px.` } };
                        }
                        return {};
                    }
                },
            },
            {
                type: 'number',
                properties: {
                    isVisible: ({ properties }) => properties.target === 'dialog',
                    label: 'Dialog height',
                    name: 'properties.dialogHeight',
                },
                constraints: { 
                    custom: data => {
                        if(data?.properties?.dialogHeight < 480){
                            return { 
                                format: { 
                                    pattern: /somefaketest/, 
                                    message: `Min dialog height 480px.` } };
                        }
                        return {};
                    }
                },
            },
        ],
    },
    {
        header: 'Events',
        children: [onLoad, onChange, isVisible, settingsValues?.viewType !== 'class' && isDisabled].filter(Boolean),
    },
    {
        header: 'Validation',
        children: [
            settingsValues?.viewType !== 'class'
                ? classRequired
                : {
                    ...classRequired,
                    properties: {
                        ...classRequired.properties,
                        disabled: data => data?.properties?.disabled === true || !!data?.properties?.static,
                    },
                },
            settingsValues?.viewType === 'class' && readOnly,
            settingsValues?.viewType === 'class' && staticAttribute(settingsValues),
        ].filter(Boolean),
    },
    {
        header: 'Styles',
        children: [flexGrow],
    },
    {
        header: 'Helpers',
        children: [help],
    },
];

export default {
    defaults: { withDefault: true, target: '_blank' },
    panels: settingsValues => panels(settingsValues),
};
